"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));

/**
 *
 * Entry point for tesseract.js, should be the entry when bundling.
 *
 * @fileoverview entry point for tesseract.js
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */
var utils = require('tesseract.js-utils');

var TesseractWorker = require('./common/TesseractWorker');

var types = require('./common/types');

module.exports = (0, _extends2.default)({
  /** Worker for OCR, @see common/TesseractWorker.js */
  TesseractWorker: TesseractWorker,

  /** Utilities for tesseract.js, @see {@link https://www.npmjs.com/package/tesseract.js-utils} */
  utils: utils
}, types);